// rxjs-extension/reactives/client/intersection.ts
import { Observable } from "rxjs";
var IntersectionObserverObservable = class extends Observable {
  constructor(targets, options = {}) {
    const normalizedTargets = targets instanceof NodeList ? Array.from(targets) : Array.isArray(targets) ? targets : [targets];
    super((subscriber) => {
      this.observer = new IntersectionObserver(
        (entries) => {
          const intersectingEntries = entries.filter((entry) => !!entry.isIntersecting);
          const resultForTarget = intersectingEntries.find((x) => normalizedTargets.includes(x.target));
          if (resultForTarget)
            subscriber.next(resultForTarget);
          else
            subscriber.next(null);
        },
        { ...options, threshold: [0.1, 1] }
      );
      normalizedTargets.forEach((target) => this.observer.observe(target));
    });
  }
};
export {
  IntersectionObserverObservable
};
